import { BaseText } from '@/src/components/BaseText'
import { FlexRow } from '@/src/components/flex'
import { appColors } from '@/src/theme'
import { Box } from '@chakra-ui/react'
import { Info as InfoIcon } from 'react-feather'
import { useTranslation } from 'react-i18next'

export const ReferenceTimePeriodOutdatedInfo = () => {
  const { t } = useTranslation()

  return (
    <Box bg='blue.100' border='1px solid' borderColor='blue.200' borderRadius='md' mt='16px' p='8px'>
      <FlexRow gap='8px' alignItems='flex-start'>
        <InfoIcon size={16} color={appColors.blue['800']} style={{ minWidth: 16, minHeight: 16, marginTop: 2 }} />
        <BaseText color='blue.800'>{t('components.procurement.forecasting.reference_period_modal.outdated_last_365_info')}</BaseText>
      </FlexRow>
    </Box>
  )
}
